export default "__VITE_ASSET__BO7rJ5l$__"